import { WhereClauseWithCondition } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isObjectRecord } from "./isObjectRecord";
import { isWhereClauseCondition } from "./isWhereClauseCondition";

/**
 * Type guard to check if a value is a WhereClauseWithCondition.
 *
 * @param obj - The value to check
 * @returns True if the value is a WhereClauseWithCondition
 */
export const isWhereClauseWithCondition = (obj: unknown): obj is WhereClauseWithCondition => {
  if (!isObjectRecord(obj)) return false;
  const objectRecord = obj;
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  // Must have a valid condition
  if (!isWhereClauseCondition(objectRecord.condition)) return false;

  // Must not have compoundExpression property
  if (objectRecord.compoundExpression !== undefined) return false;

  return true;
};
